// extracted by mini-css-extract-plugin
export default {"supportTabsDiv":"PreviewTabs_supportTabsDiv__Z9eEY","supportTab":"PreviewTabs_supportTab__-E8dO","yellowBackground":"PreviewTabs_yellowBackground__zXUxB"};